module.exports = __webpack_public_path__ + "img/inscripciones.cd8be0b2.svg";